import Navigation from '../components/layout/Navigation';
import { Shield } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <Navigation />
      
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-2xl mb-4">
            <Shield className="w-8 h-8 text-green-600" />
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Politică de Confidențialitate (Conformă GDPR) - FII FIT
          </h1>
          <p className="text-lg text-gray-600">
            Data intrării în vigoare: 19 februarie 2026
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border-2 border-gray-100">
          <div className="prose prose-lg max-w-none">

            <div className="p-6 bg-green-50 border-2 border-green-200 rounded-xl mb-8">
              <p className="text-base text-gray-800 mb-0">
                <strong>INTRODUCERE:</strong> SC GONGA SHOP SRL ("Compania", "noi"), în calitate de operator de date, se angajează să protejeze confidențialitatea și securitatea datelor dumneavoastră cu caracter personal. Această Politică de Confidențialitate descrie modul în care colectăm, utilizăm, prelucrăm și protejăm informațiile dumneavoastră atunci când utilizați aplicația mobilă FII FIT ("Aplicația"), în conformitate cu Regulamentul (UE) 2016/679 (Regulamentul General privind Protecția Datelor - "GDPR").
              </p>
            </div>

            <h2>1. Informații Generale</h2>

            <h3>1.1. Scop și Aplicabilitate</h3>
            <p>
              Această politică se aplică tuturor utilizatorilor Aplicației FII FIT. Scopul său este de a vă informa în mod transparent despre: ce date colectăm, de ce le colectăm, cum le utilizăm și care sunt drepturile dumneavoastră în legătură cu aceste date.
            </p>

            <h3>1.2. Operatorul de Date</h3>
            <p>
              Operatorul datelor dumneavoastră cu caracter personal este SC GONGA SHOP SRL cu sediul în AGIGEA, strada Nicolae Titulescu 16, județul Constanța, România. Pentru orice întrebări legate de protecția datelor, puteți contacta Responsabilul nostru cu Protecția Datelor (DPO) la <a href="mailto:office@fiifit.ro">office@fiifit.ro</a>.
            </p>

            <h2>2. Datele cu Caracter Personal Colectate</h2>
            <p>
              Colectăm diferite tipuri de informații pentru a furniza și îmbunătăți serviciile noastre. Acestea includ:
            </p>

            <h3>2.1. Date furnizate direct de utilizator</h3>
            <ul>
              <li><strong>Date de identificare și contact:</strong> Nume, prenume, adresă de e-mail, vârstă, sex.</li>
              <li><strong>Date sensibile (categorii speciale de date):</strong> Date despre condiția fizică și stilul de viață: greutate, înălțime, obiective de fitness, nivel de activitate fizică, dietă și preferințe alimentare, alergii, somn, fotografii de progres și, opțional, informații despre starea de sănătate pe care alegeți să le introduceți pentru personalizarea recomandărilor. Colectarea acestor date se face exclusiv pe baza consimțământului dumneavoastră explicit.</li>
            </ul>

            <h3>2.2. Date colectate automat în timpul utilizării Aplicației</h3>
            <ul>
              <li><strong>Date de utilizare:</strong> Informații despre modul în care interacționați cu Aplicația (funcționalități accesate, timpul petrecut, frecvența utilizării).</li>
              <li><strong>Date despre dispozitiv:</strong> Tipul dispozitivului mobil, identificatori unici ai dispozitivului (ex: IDFA, Google Ad ID), sistem de operare, adresa IP, informații despre rețeaua mobilă.</li>
            </ul>

            <h2>3. Scopul și Temeiul Juridic al Prelucrării</h2>
            <p>
              Prelucrăm datele dumneavoastră în următoarele scopuri și pe baza următoarelor temeiuri juridice:
            </p>

            <h3>3.1. Furnizarea serviciilor personalizate ale Aplicației</h3>
            <ul>
              <li><strong>Scop:</strong> Utilizarea datelor medicale și de stil de viață pentru a antrena și opera algoritmii de IA care generează recomandări personalizate de nutriție, exerciții și management al sănătății.</li>
              <li><strong>Temei juridic:</strong> <em>Consimțământul dumneavoastră explicit</em> (Art. 6(1)(a) și Art. 9(2)(a) din GDPR), solicitat în mod clar și separat la crearea contului pentru prelucrarea categoriilor speciale de date (date de sănătate).</li>
            </ul>

            <h3>3.2. Administrarea contului și comunicare</h3>
            <ul>
              <li><strong>Scop:</strong> Crearea și gestionarea contului de utilizator, trimiterea de notificări administrative, răspunsul la solicitările de suport.</li>
              <li><strong>Temei juridic:</strong> Executarea contractului (Termenii și Condițiile) la care sunteți parte (Art. 6(1)(b) din GDPR).</li>
            </ul>

            <h3>3.3. Îmbunătățirea și securizarea Aplicației</h3>
            <ul>
              <li><strong>Scop:</strong> Analiza datelor de utilizare (în formă agregată și anonimizată, pe cât posibil) pentru a înțelege cum este folosită Aplicația, pentru a remedia erori și pentru a dezvolta noi funcționalități. Asigurarea securității rețelelor și sistemelor noastre.</li>
              <li><strong>Temei juridic:</strong> Interesul nostru legitim (Art. 6(1)(f) din GDPR) de a oferi un serviciu funcțional, sigur și în continuă dezvoltare.</li>
            </ul>

            <h2>4. Partajarea Datelor (Destinatarii Datelor)</h2>
            <p>
              Nu vindem și nu închiriem datele dumneavoastră cu caracter personal. Putem partaja informațiile dumneavoastră doar în următoarele situații:
            </p>
            <ul>
              <li><strong>Furnizori de servicii terți:</strong> Colaborăm cu furnizori de infrastructură tehnică (ex: servicii de cloud hosting precum Amazon Web Services sau Google Cloud) care stochează datele în numele nostru. Acești parteneri sunt obligați contractual să respecte confidențialitatea și securitatea datelor și acționează ca persoane împuternicite de operator.</li>
              <li><strong>Specialiști parteneri:</strong> Datele dumneavoastră pot fi partajate cu antrenori, nutriționiști sau alți specialiști parteneri <strong>doar cu consimțământul dumneavoastră specific și explicit</strong> pentru fiecare astfel de partajare.</li>
              <li><strong>Obligații legale:</strong> Putem divulga datele dumneavoastră dacă acest lucru este cerut de lege sau în cadrul unei proceduri judiciare.</li>
            </ul>

            <h2>4.1. Partajarea Datelor cu Serviciul de Inteligență Artificială (OpenAI)</h2>
            
            <div className="p-6 bg-blue-50 border-2 border-blue-200 rounded-xl my-6">
              <p className="text-base text-gray-800 mb-4">
                <strong>IMPORTANT:</strong> Aplicația FII FIT utilizează serviciul de inteligență artificială furnizat de <strong>OpenAI, L.L.C.</strong> (San Francisco, SUA) pentru a genera recomandări personalizate de sănătate, nutriție, exerciții fizice și suport emoțional.
              </p>
            </div>

            <h3>4.1.1. Ce date sunt trimise către OpenAI</h3>
            <p>
              Următoarele categorii de date cu caracter personal pot fi transmise către FII FIT AI în scopul generării de recomandări personalizate:
            </p>
            <ul>
              <li><strong>Date din profilul medical:</strong> Afecțiuni cronice și autoimune, simptome, tratamente curente, alergii, istoric medical relevant.</li>
              <li><strong>Date biometrice:</strong> Vârstă, sex, greutate, înălțime, nivel de activitate fizică.</li>
              <li><strong>Obiective de sănătate:</strong> Obiectivele selectate de utilizator (ex: slăbire, creștere masă musculară, reducere inflamație, etc.).</li>
              <li><strong>Conținutul conversațiilor AI:</strong> Mesajele trimise în chat-ul cu nutriționistul AI și chat-ul terapeutic AI.</li>
              <li><strong>Date despre stilul de viață:</strong> Preferințe alimentare, nivel de mobilitate, mod de viață (sănătos/cronic).</li>
            </ul>

            <h3>4.1.2. Scopul partajării</h3>
            <p>
              Datele sunt transmise către FII FIT AI exclusiv pentru următoarele funcționalități ale Aplicației:
            </p>
            <ul>
              <li>Generarea listelor de alimente permise și interzise personalizate</li>
              <li>Crearea planurilor de mese personalizate</li>
              <li>Generarea programelor de exerciții adaptate</li>
              <li>Răspunsuri personalizate în chat-ul cu nutriționistul AI</li>
              <li>Suport emoțional personalizat în chat-ul terapeutic AI</li>
              <li>Analiza imaginilor alimentare pentru tracking nutrițional</li>
              <li>Generarea planurilor personalizate de sănătate pe dashboard</li>
            </ul>

            <h3>4.1.3. Garanții de protecție</h3>
            <p>
              FII FIT AI acționează ca <strong>persoană împuternicită de operator</strong> în conformitate cu Art. 28 din GDPR. Am implementat următoarele garanții:
            </p>
            <ul>
              <li><strong>Acord de prelucrare a datelor (DPA):</strong> Am încheiat un acord de prelucrare a datelor cu FII FIT AI care respectă cerințele GDPR.</li>
              <li><strong>Fără antrenare pe datele dvs.:</strong> FII FIT AI <strong>nu utilizează</strong> datele trimise prin API pentru antrenarea sau îmbunătățirea modelelor sale de inteligență artificială.</li>
              <li><strong>Retenție limitată:</strong> Datele sunt păstrate de FII FIT AI pentru o perioadă maximă de 30 de zile în scopuri de monitorizare a abuzurilor, după care sunt șterse automat.</li>
              <li><strong>Criptare:</strong> Toate datele sunt transmise criptat (TLS 1.2+) și stocate criptat.</li>
              <li><strong>Clauze Contractuale Standard:</strong> Transferul de date către SUA este protejat prin Clauzele Contractuale Standard (SCC) adoptate de Comisia Europeană.</li>
            </ul>

            <h3>4.1.4. Consimțământul utilizatorului</h3>
            <p>
              Înainte de prima utilizare a oricărei funcționalități AI, aplicația solicită <strong>consimțământul explicit</strong> al utilizatorului, informându-l despre ce date sunt trimise, cui sunt trimise și în ce scop. Utilizatorul poate refuza acest consimțământ, caz în care funcționalitățile AI nu vor fi disponibile. Consimțământul poate fi retras în orice moment din secțiunea Setări a aplicației.
            </p>

            <h2>5. Măsuri de Securitate a Datelor</h2>
            <p>
              Implementăm măsuri tehnice și organizatorice adecvate pentru a proteja datele dumneavoastră împotriva distrugerii, pierderii, alterării, divulgării neautorizate sau accesului neautorizat. Aceste măsuri includ:
            </p>
            <ul>
              <li><strong>Criptarea datelor:</strong> Criptarea datelor atât în tranzit (folosind TLS/SSL), cât și în repaus (at-rest encryption).</li>
              <li><strong>Controlul accesului:</strong> Accesul la datele cu caracter personal este strict limitat la personalul autorizat care are nevoie de aceste informații pentru a-și îndeplini sarcinile.</li>
              <li><strong>Pseudonimizare și anonimizare:</strong> Utilizarea tehnicilor de pseudonimizare ori de câte ori este posibil pentru a reduce riscurile asociate prelucrării.</li>
              <li><strong>Audituri de securitate:</strong> Evaluări periodice ale infrastructurii și politicilor noastre de securitate.</li>
            </ul>

            <h2>6. Drepturile Utilizatorului (conform GDPR)</h2>
            <p>
              În conformitate cu GDPR, aveți următoarele drepturi cu privire la datele dumneavoastră cu caracter personal:
            </p>
            <ul>
              <li><strong>Dreptul de acces (Art. 15):</strong> Dreptul de a obține o confirmare că prelucrăm datele dumneavoastră și de a accesa aceste date.</li>
              <li><strong>Dreptul la rectificare (Art. 16):</strong> Dreptul de a solicita corectarea datelor inexacte sau completarea datelor incomplete.</li>
              <li><strong>Dreptul la ștergere ("dreptul de a fi uitat") (Art. 17):</strong> Dreptul de a solicita ștergerea datelor dumneavoastră în anumite condiții.</li>
              <li><strong>Dreptul la restricționarea prelucrării (Art. 18):</strong> Dreptul de a solicita limitarea modului în care prelucrăm datele dumneavoastră.</li>
              <li><strong>Dreptul la portabilitatea datelor (Art. 20):</strong> Dreptul de a primi datele pe care ni le-ați furnizat într-un format structurat, utilizat în mod curent și care poate fi citit automat.</li>
              <li><strong>Dreptul la opoziție (Art. 21):</strong> Dreptul de a vă opune prelucrării datelor bazate pe interesul nostru legitim.</li>
              <li><strong>Dreptul de a retrage consimțământul:</strong> Vă puteți retrage consimțământul pentru prelucrarea datelor de sănătate în orice moment, fără a afecta legalitatea prelucrării efectuate înainte de retragere.</li>
              <li><strong>Dreptul de a depune o plângere:</strong> Aveți dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP).</li>
            </ul>
            <p>
              Pentru a vă exercita aceste drepturi, vă rugăm să ne contactați la <a href="mailto:office@fiifit.ro">office@fiifit.ro</a>.
            </p>

            <h2>7. Perioada de Păstrare a Datelor</h2>
            <p>
              Vom păstra datele dumneavoastră cu caracter personal doar pe perioada necesară îndeplinirii scopurilor pentru care au fost colectate. În general, datele asociate contului dumneavoastră vor fi păstrate pe durata existenței contului. La ștergerea contului, datele vor fi eliminate sau anonimizate într-un interval de timp rezonabil, cu excepția cazului în care suntem obligați legal să le păstrăm pentru o perioadă mai lungă.
            </p>

            <h2>8. Transferuri Internaționale de Date</h2>
            <p>
              Datele dumneavoastră pot fi stocate și prelucrate în orice țară în care avem facilități sau în care angajăm furnizori de servicii. În cazul în care transferăm date în afara Spațiului Economic European (SEE), ne vom asigura că transferul se realizează în conformitate cu legislația aplicabilă, prin implementarea unor garanții adecvate, cum ar fi Clauzele Contractuale Standard adoptate de Comisia Europeană.
            </p>

            <h2>9. Modificări ale Politicii de Confidențialitate</h2>
            <p>
              Ne rezervăm dreptul de a actualiza această Politică de Confidențialitate periodic. Vă vom notifica cu privire la orice modificare semnificativă prin publicarea noii politici în Aplicație și, dacă este cazul, printr-o notificare directă. Vă încurajăm să revizuiți periodic această pagină pentru cele mai recente informații.
            </p>

            <h2>10. Contact</h2>
            <p>
              Pentru orice întrebări, nelămuriri sau pentru exercitarea drepturilor dumneavoastră privind protecția datelor, vă rugăm să contactați Responsabilul nostru cu Protecția Datelor (DPO) la adresa de e-mail: <a href="mailto:office@fiifit.ro">office@fiifit.ro</a>
            </p>
            <p className="text-sm text-gray-600 mt-4">
              <strong>SC GONGA SHOP SRL</strong> · CUI: RO40071310 · Tel: 0787-569.002
            </p>

            <div className="mt-12 p-6 bg-gray-50 border-2 border-gray-200 rounded-xl text-center">
              <p className="text-sm text-gray-600 mb-0">
                © 2026 SC GONGA SHOP SRL. Toate drepturile rezervate. | FII FIT
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
